export enum RequestState {
	IDLE,
	PENDING,
	SUCCESS,
	ERROR,
}

export enum ModalType {
	ERROR,
	CONFIRM,
	SHARE_PICK,
	SECONDARY_REGISTRATION,
	SAVE_LOCAL_PREDICTION,
}

export enum SortOrder {
	ASC = "asc",
	DESC = "desc",
}

export enum SocialNetwork {
	Facebook,
	Twitter,
	Mobile,
}

export enum SocialType {
	Facebook = "facebook",
	Twitter = "twitter",
	Whatsapp = "whatsapp",
}

export enum ShareType {
	Winner = "winner",
	UserPick = "userPick",
}

export enum Locale {
	EN_US = "en-US",
	ES_ES = "es-ES",
}

export enum Language {
	EN = "en",
	ES = "es",
}

export enum LeaguePrivacy {
	PUBLIC = "public",
	PRIVATE = "private",
}

export enum LeagueType {
	REGULAR = "regular",
	OVERALL = "overall",
}

export enum LeagueStatus {
	COMPLETE = "complete",
	PLAYING = "playing",
	SCHEDULED = "scheduled",
}

export enum ContestStatus {
	LIVE = "live",
	SCHEDULED = "scheduled",
	RESULTED = "resulted",
	POSTPONED = "postponed",
	SUSPENDED = "suspended",
}

export enum RoundStatus {
	LIVE = "playing",
	SCHEDULED = "scheduled",
	COMPLETED = "complete",
}

export enum GameStatus {
	PLAYING = "playing",
	COMPLETED = "complete",
	SCHEDULED = "scheduled",
	POSTPONED = "postponed",
	SUSPENDED = "suspended",
	CANCELED = "canceled",
}

export enum WinnerCount {
	SINGLE = "single",
	DOUBLE = "double",
	EQUAL = "equal",
}

export enum Syndication {
	FAN = "fan",
	MEDIA = "media",
}

export enum Handedness {
	LEFT = "left",
	RIGHT = "right",
	PITCHER = "pitcher",
}

export enum LeaderboardType {
	OVERALL = "overall",
	FAN = "fan",
	PERSONAL = "personal",
}

export enum ContextualProjects {
	BEAT_THE_STREAK = "beat_the_streak",
	BY_THE_NUMBER = "by_the_number",
	SPINBALL = "spinball",
	PLAYER_OF_THE_GAME = "player_of_the_game",
}
